import React from 'react'
import SarasTrans from '../../../library/notifications/SarasTrans';

//starting with capital letter will ensure this is treated as a component
const InvSOGridItemH = ({col}) => {

    return (
        <div className="uiSearchSubList">
            <span className="sItemCode uiCenter"><SarasTrans value="Item Code" /></span>
            <span className="sItemID uiCenter"><SarasTrans value="Item Name" /></span>
            <span className="sItemWeight uiCenter"><SarasTrans value="SO Qty" /></span>
            <span className="sItemWeight uiCenter"><SarasTrans value="SR Qty" /></span>
        </div>
    );
}

export default InvSOGridItemH
